import { render, staticRenderFns } from "./TheCustomerListV2.vue?vue&type=template&id=466cc64a&scoped=true&"
import script from "./TheCustomerListV2.vue?vue&type=script&lang=js&"
export * from "./TheCustomerListV2.vue?vue&type=script&lang=js&"
import style0 from "./TheCustomerListV2.vue?vue&type=style&index=0&id=466cc64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466cc64a",
  null
  
)

export default component.exports